import React, {useEffect, useState} from 'react';
import {NavLink, useLocation} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {setOpenBurgerAC} from "app/app-reduser";
import {setFormFeedbackAC} from "app/popups-reducer";
import {ROLE_TEACHER} from "entities/constants/constants";
import {MenuConfig, menuConfig, RoleConfig} from "components/header/navigate/menuConfig";


export const NavBar: React.FC = () => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const [activeItem, setActiveItem] = useState<number>(() => {
        const storedActiveItem = localStorage.getItem('activeItem');
        return storedActiveItem ? parseInt(storedActiveItem, 10) : 0;
    });
    const location = useLocation();
    const isFormFeedback = useAppSelector((state) => state.popups.isFormFeedback);
    const dispatch = useAppDispatch();

    const onClickHandler = () => {
        dispatch(setFormFeedbackAC(!isFormFeedback));
    };

    const handleClick = (index: number) => {
        dispatch(setOpenBurgerAC(false));
        setActiveItem(index);
    };

    useEffect(() => {
        localStorage.setItem('activeItem', activeItem.toString());
    }, [activeItem]);

    const isMenuItemActive = (path: string) => {
        if (path === '/') {
            return location.pathname === path;
        }
        return location.pathname.startsWith(path);
    };

    const getMenuItems = (roleConfig: RoleConfig) => {
        return roleConfig.map((item, index) => (
            <li key={item.title} className={isMenuItemActive(item.path) ? 'active' : ''}>
                <NavLink to={item.path} onClick={() => handleClick(index)}>
                    {item.title} <span className="nav-item-icon">{item.icon}</span>
                </NavLink>
            </li>
        ));
    };

    return (
        <div className="sub-box">
            <nav className="app-nav">
                <ul>
                    {getMenuItems(menuConfig[roleType as keyof MenuConfig] || [])}

                    {roleType !== ROLE_TEACHER ? (
                        <li className="btn-item" onClick={onClickHandler}>
                            <span className="btn small"><span>Оставить отзыв</span></span>
                        </li>
                    ) : null}
                </ul>
            </nav>
        </div>
    );
}
